namespace Nobox.CRM {
    export interface DealsForm {
        Nm: Serenity.StringEditor;
        CryId: CurrencyEditor;
        Prc: AutoNumericEditor;
        IsDone: Serenity.BooleanEditor;
        Assign: Serenity.ServiceLookupEditor;
        ClsDt: CustomDateTimeEditor;
        SrcId: Serenity.StringEditor;
        Src: DealsSourceEditor;
        LostR: DealsLostReasonEditor;
        PlId: Serenity.ServiceLookupEditor;
        piplinetypes: Serenity.ServiceLookupEditor;
        PlTags: Serenity.ServiceLookupEditor;
        StDt: CustomDateTimeEditor;
        ExpDt: CustomDateTimeEditor;
        PriorityId: Serenity.EnumEditor;
        GrpId: Serenity.ServiceLookupEditor;
        Grp: Serenity.StringEditor;
        CtIds: Serenity.StringEditor;
        PdtIds: Serenity.StringEditor;
        Pdt: Serenity.TextAreaEditor;
        CtDeal: PickerContactdealsEditor;
        Pdts: ProductDealsEditor;
        In: CustomDateTimeEditor;
        Up: CustomDateTimeEditor;
        InBy: Serenity.ServiceLookupEditor;
        UpBy: Serenity.ServiceLookupEditor;
    }

    export class DealsForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Deals';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DealsForm.init)  {
                DealsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = CurrencyEditor;
                var w2 = AutoNumericEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.ServiceLookupEditor;
                var w5 = CustomDateTimeEditor;
                var w6 = DealsSourceEditor;
                var w7 = DealsLostReasonEditor;
                var w8 = s.EnumEditor;
                var w9 = s.TextAreaEditor;
                var w10 = PickerContactdealsEditor;
                var w11 = ProductDealsEditor;

                Q.initFormType(DealsForm, [
                    'Nm', w0,
                    'CryId', w1,
                    'Prc', w2,
                    'IsDone', w3,
                    'Assign', w4,
                    'ClsDt', w5,
                    'SrcId', w0,
                    'Src', w6,
                    'LostR', w7,
                    'PlId', w4,
                    'piplinetypes', w4,
                    'PlTags', w4,
                    'StDt', w5,
                    'ExpDt', w5,
                    'PriorityId', w8,
                    'GrpId', w4,
                    'Grp', w0,
                    'CtIds', w0,
                    'PdtIds', w0,
                    'Pdt', w9,
                    'CtDeal', w10,
                    'Pdts', w11,
                    'In', w5,
                    'Up', w5,
                    'InBy', w4,
                    'UpBy', w4
                ]);
            }
        }
    }
}
